import { render, staticRenderFns } from "./platform_rule_add.vue?vue&type=template&id=297f8f98"
import script from "./platform_rule_add.vue?vue&type=script&lang=js"
export * from "./platform_rule_add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports